import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { signInWithGoogle } from '../../firebase';
import { UserContext } from '../../providers/UserProvider';

const Login = () => {
    const user = useContext(UserContext);

    const handleSignIn = () => {
        signInWithGoogle().catch((error) => {
            console.error('Auth error: ', error.message);
        });
    };

    return (
        <main className="relative mx-auto container max-w-lg">
            {user ? (
                <>
                    <h1 className="mt-40 mb-4 text-center uppercase tracking-wide text-2xl ml-4 text-purple-900 font-semibold">
                        HOLA {user.email}
                    </h1>
                    <Link
                        to="/admin/create"
                        className="relative block text-center mx-auto mt-8 py-4 px-8 bg-green-500 text-white font-semibold rounded-lg shadow-md hover:bg-green-700 focus:outline-hidden focus:ring-2 focus:ring-green-400/75">
                        Continuar
                    </Link>
                </>
            ) : (
                <>
                    <h1 className="mt-40 mb-4 text-center uppercase tracking-wide text-2xl ml-4 text-purple-900 font-semibold">
                        LOGIN TO ADMIN
                    </h1>
                    <div className="bg-white rounded-xl shadow-md overflow-hidden p-8 text-center">
                        <p className="mb-6 text-gray-600">This is a private application, please login.</p>
                        <button
                            onClick={handleSignIn}
                            className="cursor-pointer mx-auto py-4 px-8 bg-green-500 text-white font-semibold rounded-lg shadow-md hover:bg-green-700 focus:outline-hidden focus:ring-2 focus:ring-green-400/75">
                            SIGN IN WITH GOOGLE
                        </button>
                    </div>
                </>
            )}
        </main>
    );
};

export default Login;
